import * as avatarSelectorActions from '../../actions/avatarSelector'

const initialState = {
  face: -1,
  skin: '#CCCCCC',
  hair: '#000000'
}
const avatarBuilder = (state = initialState, action) => {
  switch (action.type) {
    case avatarSelectorActions.SELECT_FACE_TYPE:
      return {
        ...state,
        face: action.faceType
      }

    case avatarSelectorActions.SELECT_SKIN_TYPE:
      return {
        ...state,
        skin: action.skinType
      }

    case avatarSelectorActions.SELECT_HAIR_TYPE:
      return {
        ...state,
        hair: action.hairType
      }

    default:
      return state
  }
}

export default avatarBuilder
